import {
  Cascader,
  Col,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Slider,
  Space,
  Table,
  TreeSelect,
  message,
} from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { MainLayout } from 'components';
import { useEffect, useState } from 'react';
import Button from 'components/Button';
import { useMutation, useQuery } from 'react-query';
import {
  EyeIcon,
  EditIcon,
  FilterIcon,
  Stroke,
  ChevronUp,
  ChevronDown,
  FilterGoldIcon,
} from 'assets/svg';
import { Content } from 'antd/es/layout/layout';
import { Link, useHistory } from 'react-router-dom';
import { optionsMockup } from 'mock/product-mockup';
import { IProduct } from 'interface/product.interface';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import useQueryParam from 'hooks/useQueryPrams';
import { HocChangePagination } from 'utils/HocChangePagination';
import { ColumnsType } from 'antd/es/table';
import formatCurrencyVND from 'utils/formatCurrencyVND';
import ProductApi from 'apis/ProductApi';
import { PRODUCT_POF_STATUS, PRODUCT_STATUS } from 'constants/productStatus';
import pageTitleStore from 'store/pageTitleStore';
import { STATUS } from 'constants/reponseStatus';
import { PageTitle } from 'constants/title';
import PriceSlider from 'components/PriceSlider';
export default function ProductListPage(): JSX.Element {
  document.title = PageTitle;
  const history = useHistory();
  const { Option } = Select;
  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  const [products, setProductData] = useState<IProduct[]>([]);
  const [total, setProductTotalData] = useState<number>(0);

  const [advancedSearch, setAdvancedSearch] = useState<boolean>(false);
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(true);

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [formSubmitParams, setFormSubmitParams] = useState<any>();

  const [form] = useForm();

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const toggleFilter = () => {
    setIsOpenFilter(!isOpenFilter);
  };
  const queryParam = useQueryParam();
  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;
  const search = queryParam.get('search') || undefined;
  const fullName = queryParam.get('fullName') || undefined;
  const email = queryParam.get('email') || undefined;
  const jobTitleCode = queryParam.get('jobTitleCode') || undefined;
  const departmentCode = queryParam.get('departmentCode') || undefined;
  const plantCode = queryParam.get('plantCode') || undefined;
  const categoryParams: any = {
    page,
    page_size,
    search,
    fullName,
    email,
    jobTitleCode,
    departmentCode,
    plantCode,
  };
  const params = {
    page: page,
    page_size: page_size,
    ...(formSubmitParams && formSubmitParams),
  };

  const { mutate: getProducts, isLoading: isProductLoading } = useMutation(
    ['getProducts'],
    () => ProductApi.get(params),
    {
      onSuccess: (res: any) => {
        setProductData(res.data);
        setProductTotalData(res.total);
      },
      onError: (err: any) => {
        console.log(err);
      },
    }
  );

  // const { data: lstNhanHang } = useQuery(
  //   ['getProductGroup'],
  //   () => ProductApi.getProductGroup(3) // lấy ds nhãn hàng
  // );

  // const { data: lstNganhHang } = useQuery(
  //   ['getNganhHang'],
  //   () => ProductApi.getProductGroup(2) // lấy ds ngành hàng
  // );

  // const { data: lstProductOption } = useQuery(
  //   ['getProductOption'],
  //   () => ProductApi.getProductOption() // lấy ds option
  // );

  // const chungloai = lstProductOption?.data?.filter(
  //   (option: any) => option.type === 'chungloai'
  // )[0]['list'];

  // const gioitinh = lstProductOption?.data?.filter(
  //   (option: any) => option.type === 'gioitinh'
  // )[0]['list'];
  const { data: lstProductOption } = useQuery(
    ['getProductOption'],
    () => ProductApi.getProductOption() // lấy ds option
  );

  const pthh_list = lstProductOption?.data?.filter(
    (option: any) => option.type === 'plhh'
  );
  const plhh =
    pthh_list == undefined || pthh_list.length == 0 ? [] : pthh_list[0]['list'];

  const nhanhang = lstProductOption?.data?.filter(
    (option: any) => option.type === 'nhanhang'
  )[0]['list'];

  const donghang = lstProductOption?.data?.filter(
    (option: any) => option.type === 'line_xman'
  )[0]['list'];

  const nganhhang = lstProductOption?.data?.filter(
    (option: any) => option.type === 'nganhhang'
  )[0]['list'];

  const chungloai = lstProductOption?.data?.filter(
    (option: any) => option.type === 'chungloai'
  )[0]['list'];

  const bst = lstProductOption?.data?.filter(
    (option: any) => option.type === 'bst'
  )[0]['list'];

  const phankhuc = lstProductOption?.data?.filter(
    (option: any) => option.type === 'phankhuc'
  )[0]['list'];

  const phankhucgia = lstProductOption?.data?.filter(
    (option: any) => option.type === 'phankhuc_gia'
  )[0]['list'];

  const costprice = lstProductOption?.data?.filter(
    (option: any) => option.type === 'cost_price'
  )[0]['data'];

  const price = lstProductOption?.data?.filter(
    (option: any) => option.type === 'price'
  )[0]['data'];

  const loaida = lstProductOption?.data?.filter(
    (option: any) => option.type === 'loai_da'
  )[0]['list'];

  const nhomda = lstProductOption?.data?.filter(
    (option: any) => option.type === 'nhom_da'
  )[0]['list'];

  const donghangsap = lstProductOption?.data?.filter(
    (option: any) => option.type === 'donghang'
  )[0]['list'];

  const gioitinh = lstProductOption?.data?.filter(
    (option: any) => option.type === 'gioitinh'
  )[0]['list'];

  const bo = lstProductOption?.data?.filter(
    (option: any) => option.type === 'bo'
  )[0]['list'];

  const cap = lstProductOption?.data?.filter(
    (option: any) => option.type === 'cap'
  )[0]['list'];

  const xman = lstProductOption?.data?.filter(
    (option: any) => option.type === 'xman'
  )[0]['list'];

  const kldg_3tc = lstProductOption?.data?.filter(
    (option: any) => option.type === 'kldg_3tc'
  )[0]['list'];

  const materialtype_list = lstProductOption?.data?.filter(
    (option: any) => option.type === 'material_type'
  );

  const materialtype =
    materialtype_list == undefined || materialtype_list.length == 0
      ? []
      : materialtype_list[0]['list'];

  const onFinish = (values: any) => {
    const filteredData = Object.fromEntries(
      Object.entries(values).filter(([_, value]) => value !== undefined)
    );
    const stringifiedData: { [key: string]: string } = {};
    Object.keys(filteredData).forEach((key) => {
      if (key == 'cost_price') {
        const values: any = filteredData[key];
        stringifiedData['min_cost_price'] = values[0];
        stringifiedData['max_cost_price'] = values[1];
      } else {
        stringifiedData[key] = String(filteredData[key]);
      }
    });
    setFormSubmitParams(stringifiedData);
    history.push('/product', {
      page: 1,
      page_size: page_size,
    });
  };

  const handleReset = () => {
    form.resetFields();
    setFormSubmitParams(undefined);
  };

  const columns: ColumnsType<any> = [
    {
      title: 'STT',
      dataIndex: 'id',
      width: 80,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Hình ảnh',
      dataIndex: 'image_default',
      render: (image_default) => (
        <img style={{ height: 50 }} src={image_default} />
      ),
      width: 100,
    },
    {
      title: 'Mã basic (new)',
      dataIndex: 'basic_product',
      width: 177,
    },
    {
      title: 'Mã mẫu',
      dataIndex: 'pro_tpl_code',
      width: 177,
    },
    {
      title: 'Mã sản phẩm',
      dataIndex: 'product_code',
      width: 261,
    },
    {
      title: 'Tên sản phẩm',
      dataIndex: 'product_name',
      width: 261,
    },
    {
      title: 'Ngành hàng',
      width: 115,
      dataIndex: 'prod_grp2_name',
    },
    {
      title: 'Dòng hàng SAP',
      dataIndex: 'line_sap',
      width: 148,
    },
    {
      title: 'Dòng hàng Xman',
      dataIndex: 'line_xman_text',
      width: 148,
    },
    {
      title: 'Xman',
      dataIndex: 'xman',
      width: 200,
    },
    {
      title: 'Chủng loại',
      dataIndex: 'chungloai_text',
      width: 112,
    },
    {
      title: 'Giá vốn tồn tham khảo',
      dataIndex: 'cost_price',
      width: 185,
      align: 'end',
      render: (value: number) => {
        return <>{formatCurrencyVND(value)}</>;
      },
    },
    {
      title: 'Giá bán',
      dataIndex: 'price',
      width: 135,
      align: 'end',
      render: (value: number) => {
        return <>{formatCurrencyVND(value)}</>;
      },
    },
    {
      title: 'Giá vốn bình quân',
      dataIndex: 'cost_price',
      width: 157,
      align: 'end',
      render: (value: number) => {
        return <>{formatCurrencyVND(value)}</>;
      },
    },
    {
      title: 'Phân khúc giá',
      dataIndex: 'phankhuc_gia',
      width: 157,
    },
    {
      title: 'Loại đá',
      dataIndex: 'loai_da',
      width: 124,
    },
    {
      title: 'Nhóm đá',
      dataIndex: 'nhom_da',
      width: 124,
    },
    {
      title: 'Aging',
      dataIndex: 'aging',
      width: 157,
    },
    {
      title: 'BST',
      dataIndex: 'bst_text',
      width: 60,
    },
    {
      title: 'Mã bộ',
      dataIndex: 'zma_bo',
      width: 250,
    },
    {
      title: 'Mã cặp',
      dataIndex: 'zma_ts_cap',
      width: 250,
    },
    {
      title: 'Giới tính',
      dataIndex: 'gioitinh_text',
      width: 90,
    },
    {
      title: 'Material Type',
      dataIndex: 'product_type_code',
      width: 126,
    },
    {
      title: 'Tuổi vàng',
      dataIndex: 'purity_of_gold',
      width: 99,
    },
    {
      title: 'Màu sắc',
      dataIndex: 'mausac_text',
      width: 120,
    },
    {
      title: 'Size ổ hột',
      dataIndex: 'ohot_kc',
      width: 99,
    },
    {
      title: 'Xplant Status',
      dataIndex: 'xplant_status',
      width: 125,
    },
    {
      title: 'Phân nhóm',
      dataIndex: '',
      width: 204,
    },
    {
      title: 'Trạng thái mẫu',
      dataIndex: '',
      width: 135,
    },
    {
      title: 'Is_DMHHKN',
      dataIndex: 'is_dmhhkn',
      width: 115,
    },
    {
      title: 'PLHH',
      dataIndex: 'plhh',
      width: 114,
    },
    {
      title: 'Material (Mẫu đại diện)',
      dataIndex: 'mau_dai_dien',
      width: 190,
      render: (value: any) => {
        return <>{(value ?? false).toString()}</>;
      },
    },
    {
      title: 'Material Group',
      dataIndex: 'material_group',
      width: 134,
    },
    {
      title: 'PL ni => Khung ni chuẩn (hàng mới)',
      dataIndex: 'item_size',
      width: 270,
    },
    {
      title: 'DGTQ',
      dataIndex: 'kldg_3tc',
      width: 73,
    },
    {
      title: 'PL tình trạng theo dõi NLSX',
      dataIndex: '',
      width: 219,
    },
    // {
    //   title: 'Danh mục cũ',
    //   dataIndex: '',
    //   width: 121,
    // },
    // {
    //   title: 'Danh mục',
    //   dataIndex: '',
    //   width: 114,
    // },
    {
      title: 'Basic status',
      dataIndex: 'basic_status',
      width: 177,
    },
    {
      title: 'Trạng thái sản phẩm',
      width: 171,
      dataIndex: 'status',
    },
    {
      title: 'Vòng đời giỏ hàng hiện tại',
      width: '200px',
      dataIndex: '',
    },
    {
      title: 'Doanh thu 6 tháng gần nhất',
      align: 'right',
      dataIndex: 'doanhthu_6th',
      width: 210,
    },
    {
      title: 'Doanh thu TB 1 tháng (VND)',
      align: 'right',
      dataIndex: 'doanhthu_tb_1th',
      width: 220,
    },
    {
      title: 'Trạng thái bán hàng',
      width: 168,
      render: (product: IProduct) => (
        <span>
          {PRODUCT_STATUS.find((item) => item.value === product.status)?.label}
        </span>
      ),
    },
    {
      title: 'Tổng SL tồn hiện tại',
      align: 'right',
      dataIndex: 'tongsl_ton',
      width: 160,
    },
    {
      title: 'Tổng SL Tổng giá trị',
      align: 'right',
      dataIndex: 'tong_giatri',
      width: 150,
    },
    {
      title: 'Product Family',
      dataIndex: '',
      width: 150,
    },
    {
      fixed: 'right',
      width: 100,
      align: 'center',
      render: (product: IProduct) => (
        <div className="flex justify-around">
          <button
            onClick={() => {
              goToDetail(product.product_code);
            }}
          >
            <EyeIcon />
          </button>
          {/* <button>
            <EditIcon />
          </button> */}
        </div>
      ),
    },
  ];

  useEffect(() => {
    getProducts();
    setTitle('Sản phẩm');
    setBreadcrumb([{ title: <a href="/product">Sản phẩm</a> }]);
    const pageTitle = 'PNJ - PMS';
    document.title = pageTitle;
  }, [page, page_size, formSubmitParams]);

  const goToDetail = (code: string) => {
    history.push(`/product/${code}`);
  };
  return (
    <MainLayout>
      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        justify="end"
        className="mb-1"
      >
        <Col span={12} className="flex justify-end">
          <Space>
            <Button
              onClick={() => {
                // message.warning('Vui lòng chọn sản phẩm cần cập nhật');
                const selectedProducts = products.filter((product) =>
                  selectedRowKeys.includes(product.id)
                );
                history.push('/product-update', {
                  selectedProducts,
                });
              }}
            >
              <Stroke />
              Cập nhật sản phẩm
            </Button>

            <Button
              bgColor={'bg-white'}
              color={`${
                isOpenFilter ? 'text-primary-50' : 'text-secondary-50'
              }`}
              border={`${
                isOpenFilter ? 'border-primary-50' : 'border-secondary-50'
              }`}
              onClick={toggleFilter}
            >
              {isOpenFilter ? <FilterIcon /> : <FilterGoldIcon />}
              Lọc
            </Button>
          </Space>
        </Col>
      </Row>
      <Form
        form={form}
        layout="vertical"
        className={`${isOpenFilter ? '' : 'hidden'}`}
        onFinish={onFinish}
        autoComplete="off"
        size="small"
      >
        <Content
          className="mt-4"
          style={{ paddingTop: '10px', paddingBottom: '10px' }}
        >
          {/* <Row gutter={[8, 0]}> */}
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" span={6}>
              <Form.Item
                name="basic_product"
                label="Mã basic (new)"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Input
                  placeholder="Nhập mã basic (new)"
                  size="small"
                  style={{ padding: '9px 16px' }}
                />
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={6}>
              <Form.Item
                name="pro_tpl_code"
                label="Mã mẫu"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Input
                  placeholder="Nhập mã mẫu"
                  className=""
                  style={{ padding: '9px 16px' }}
                />
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={6}>
              <Form.Item
                name="product_code"
                label="Mã sản phẩm"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Input
                  placeholder="Nhập mã sản phẩm"
                  className=""
                  style={{ padding: '9px 16px' }}
                />
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={6}>
              <Form.Item
                name="product_name"
                label="Tên sản phẩm"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Input
                  placeholder="Nhập Tên sản phẩm"
                  className=""
                  style={{ padding: '9px 16px' }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" span={6}>
              <Form.Item
                name="brand_code"
                label="Nhãn hàng"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Select placeholder="Chọn nhãn hàng" allowClear>
                  {nhanhang?.map((item: any) => (
                    <Option key={item.prod_grp3} value={item.prod_grp3}>
                      {item.prod_grp3_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={6}>
              <Form.Item
                name="chung_loai"
                label="Chủng loại"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Select placeholder="Chọn chủng loại" allowClear>
                  {chungloai &&
                    chungloai.map((item: any) => (
                      <Option value={item.chungloai} key={item.chungloai}>
                        {item.chungloai_text}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>

            <Col className="gutter-row" span={6}>
              <Form.Item
                name="grp_code"
                label="Ngành hàng"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Select placeholder="Chọn ngành hàng" allowClear>
                  {nganhhang?.map((item: any) => (
                    <Option value={item.prod_grp2} key={item.prod_grp2}>
                      {item.prod_grp2_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col className="gutter-row" span={6}>
              <Form.Item
                name="line_xman"
                label="Dòng hàng Xman"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Select placeholder="Chọn dòng hàng Xman" allowClear>
                  {donghang &&
                    donghang.map((item: any) => (
                      <Option
                        key={item.line_xman_text}
                        value={item.line_xman_text}
                      >
                        {item.line_xman_text}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" span={6}>
              <Form.Item
                name="cost_price"
                label="Giá vốn bình quân"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                {costprice && (
                  <Slider
                    min={costprice?.min}
                    max={costprice?.max}
                    range
                    step={10}
                    tooltip={{
                      formatter: (value: any) => {
                        return formatCurrencyVND(value);
                      },
                    }}
                    defaultValue={[costprice?.min, costprice?.max]}
                  />
                  // <PriceSlider price={costprice} />
                )}
              </Form.Item>
            </Col>

            <Col className="gutter-row" span={6}>
              <Form.Item
                name="phankhuc_gia"
                label="Phân khúc giá"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Select placeholder="Chọn phân khúc giá" allowClear>
                  {phankhucgia &&
                    phankhucgia.map((item: any) => (
                      <Option key={item.phankhuc_gia} value={item.phankhuc_gia}>
                        {item.phankhuc_gia}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>

            <Col className="gutter-row" span={6}>
              <Form.Item
                name="bst"
                label="Bộ sưu tập"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Select placeholder="Chọn BST" allowClear>
                  {bst &&
                    bst.map((item: any) => (
                      <Option key={item.bst} value={item.bst}>
                        {item.bst_text}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={6}>
              <Form.Item
                name="gioitinh"
                label="Giới tính"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Select placeholder="Chọn giới tính" allowClear>
                  {gioitinh &&
                    gioitinh.map((item: any) => (
                      <Option value={item.gioitinh} key={item.gioitinh}>
                        {item.gioitinh_text}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
            <Col className="flex justify-end" span={8}>
              <Space>
                <a href="#" onClick={() => setAdvancedSearch(!advancedSearch)}>
                  <div className="flex items-center">
                    <p className="text-primary-50 font-medium">
                      Tìm kiếm nâng cao
                    </p>
                    {advancedSearch ? <ChevronUp /> : <ChevronDown />}
                  </div>
                </a>
              </Space>
            </Col>
          </Row>
          <span className={`${advancedSearch ? '' : 'hidden'}`}>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="gutter-row" span={6}>
                <Form.Item
                  name="loai_da"
                  label="Loại đá"
                  className="mb-1.5"
                  labelCol={{ style: { paddingBottom: '5px' } }}
                >
                  <Select placeholder="Chọn loại đá" allowClear>
                    {loaida &&
                      loaida.map((item: any) => (
                        <Option value={item.loai_da} key={item.loai_da}>
                          {item.loai_da}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={6}>
                <Form.Item
                  name="nhom_da"
                  label="Nhóm đá"
                  className="mb-1.5"
                  labelCol={{ style: { paddingBottom: '5px' } }}
                >
                  <Select placeholder="Chọn nhóm đá" allowClear>
                    {nhomda &&
                      nhomda.map((item: any) => (
                        <Option value={item.nhom_da} key={item.nhom_da}>
                          {item.nhom_da}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col className="gutter-row" span={6}>
                <Form.Item
                  name="ma_bo"
                  label="Mã bộ"
                  className="mb-1.5"
                  labelCol={{ style: { paddingBottom: '5px' } }}
                >
                  <Select placeholder="Chọn mã bộ" allowClear>
                    {bo &&
                      bo.map((item: any) => (
                        <Option value={item.zma_bo} key={item.zma_bo}>
                          {item.zma_bo}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={6}>
                <Form.Item
                  name="ma_cap"
                  label="Mã cặp"
                  className="mb-1.5"
                  labelCol={{ style: { paddingBottom: '5px' } }}
                >
                  <Select placeholder="Chọn mã cặp" allowClear>
                    {cap &&
                      cap.map((item: any) => (
                        <Option value={item.zma_ts_cap} key={item.zma_ts_cap}>
                          {item.zma_ts_cap}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="gutter-row" span={6}>
                <Form.Item
                  name="line_sap"
                  label="Dòng hàng SAP"
                  className="mb-1.5"
                  labelCol={{ style: { paddingBottom: '5px' } }}
                >
                  <Select placeholder="Chọn dòng hàng SAP" allowClear>
                    {donghangsap &&
                      donghangsap.map((item: any) => (
                        <Option key={item.prod_grp4} value={item.prod_grp4}>
                          {item.prod_grp4_name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={6}>
                <Form.Item
                  name="material_type"
                  label="Material type"
                  className="mb-1.5"
                  labelCol={{ style: { paddingBottom: '5px' } }}
                >
                  <Select
                    placeholder="Chọn Material Type"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {materialtype &&
                      materialtype.map((item: any) => (
                        <Option
                          key={item.material_type}
                          value={item.material_type}
                        >
                          {item.material_type}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col className="gutter-row" span={6}>
                <Form.Item
                  name="xman"
                  label="Xman"
                  className="mb-1.5"
                  labelCol={{ style: { paddingBottom: '5px' } }}
                >
                  <Select placeholder="Chọn Xman" allowClear>
                    {xman &&
                      xman.map((item: any) => (
                        <Option key={item.xman} value={item.xman}>
                          {item.xman}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </span>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="end"
            className="mt-2"
          >
            <Col className="flex justify-end" span={8}>
              <Space>
                <Button
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border={'border-primary-50'}
                  onClick={handleReset}
                >
                  Huỷ
                </Button>
                <Button type="submit">Tìm kiếm</Button>
              </Space>
            </Col>
          </Row>
        </Content>
      </Form>
      <Content className="main-content mt-4">
        <Table
          rowKey={(record) => record.id}
          size="small"
          className="customTable"
          columns={columns}
          dataSource={products}
          pagination={{
            className: 'flex items-center',
            current: page,
            pageSize: page_size,
            total: total,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            onChange: HocChangePagination(history),
          }}
          scroll={{ x: 958 }}
          loading={isProductLoading}
          rowSelection={rowSelection}
        />
      </Content>
    </MainLayout>
  );
}
